/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import cx from 'classnames';
import {
  Popup, Icon, Breadcrumb, Menu, Modal, Header
} from 'semantic-ui-react';
import Chart from 'chart.js/auto';
import FileSaver from 'file-saver';
import { withTranslation } from 'react-i18next';
import LitigatorDetailModal from '../Modal/LitigatorDetailModal';
import api from '../../api';
import WithRouter from '../Extensions/WithRouter';
import {
  //SCANS_LABEL_ARCHIVE,
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import ExportModal from '../Modal/ExportModal';
import HeaderError from '../SubHeader/HeaderError';
import HeaderLinkDetail from '../SubHeader/HeaderLinkDetail';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import NISModal from '../NISTools/NISModal';
import VexGenerator from '../SBOM/VexGenerator';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import './ComponentDetailedPanel.css';

class ComponentDetailedPanel extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.disposers = [];
    this.state = {
      isLoading: false,
      isOpenMLD: false,
      litigatorData: {},
      overviewSummary: {},
      isLoadError: false,
      errorHeader: null,
      errorBody: null,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMenu: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenAlertModal: false,
      isOpenMNA: false,
      isOpenMVX: false,
      toExport: '',
      componentCount: {
        has_risk: 0,
        total: 0,
      },
      isOpenMCB: false,
    };
  }

  componentDidMount() {
    const { state, params } = this.props;
    this.onUpdateLoading();
    $(document).on('mouseenter', '.contents_summary .list_wrap .name', this.handleMouseOver);
    $(document).on('mouseover', '.contents_summary .contents_summary_inner .contents_summary_box .summary_item_table li span', this.handleMouseOver);
    $(document).on('mouseover', '.result_header_inner .result_header_box .name .file_name span', this.handleMouseOver);
    this.disposers.push(
      reaction(
        () => { return state.user.currentPrecisionLevelActive; },
        () => {
          this.getComponentSummaryDetail(params.idReport, state.user.currentPrecisionLevel);
        }
      ),
      reaction(
        () => { return state.user.isUpdateComponentList; },
        () => {
          if (state.user.isUpdateComponentList) {
            this.getComponentSummaryDetail(params.idReport);
          }
        }
      )
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoading, componentCount } = this.state;
    const { params, state } = this.props;

    if (componentCount.total !== prevState.componentCount.total) {
      this.drawChart();
    }

    if (prevProps.params.idReport !== params.idReport) {
      this.getComponentSummaryDetail(params.idReport);
      return;
    }

    if (prevState.isLoading !== isLoading && isLoading) {
      const navState = state.user.transientNavigationState;
      const detailType = navState ? state.user.currentPrecisionLevel : undefined;

      if (navState) {
        state.user.clearTransientNavigationState();
      }
      this.getComponentSummaryDetail(params.idReport, detailType);
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.disposers.forEach((disposer) => {
      disposer();
    });
    $(document).off('mouseenter', '.contents_summary .list_wrap .name', this.handleMouseOver);
    $(document).off('mouseover', '.contents_summary .contents_summary_inner .contents_summary_box .summary_item_table li span', this.handleMouseOver);
    $(document).off('mouseover', '.result_header_inner .result_header_box .name .file_name span', this.handleMouseOver);
  }

  handleMouseOver = (event) => {
    const $this = $(event.currentTarget);
    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth && !$this.attr('title')) {
      $this.attr('title', $this.text());
    }
  };

  handleExport = () => {
    this.setState({
      modalExportIsOpen: true,
      isOpenMenu: false,
    });
  };

  handleSpdx = () => {
    this.setState({
      isOpenMCX: true,
    });
  };

  handleCycloneDx = () => {
    this.setState({
      isOpenMCD: true,
    });
  };

  handleVexBom = () => {
    this.setState({
      isOpenMVX: true,
    });
  };

  handleCBOM = () => {
    const { t } = this.props;
    const { overviewSummary } = this.state;
    const { hasCrypto } = overviewSummary;

    if (hasCrypto) {
      this.setState({
        isOpenMCB: true,
      });
    } else {
      this.modalAction = t('modal.title.notice');
      this.modalBody = t('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  };

  handleNIS = () => {
    this.setState({
      isOpenMNA: true,
    });
  };

  handleMenuOpen = () => {
    this.setState({
      isOpenMenu: true,
    });
  };

  handleMenuClose = () => {
    this.setState({
      isOpenMenu: false,
    });
  };

  handleMLDClose = () => {
    this.setState({
      isOpenMLD: false,
    });
  };

  handleLitigatorDetailModal = (e, string) => {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api
      .getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleBookmark = () => {
    const { overviewSummary } = this.state;
    const { location, state } = this.props;
    let currentViewPoint;
    if (location.pathname.indexOf('overview') !== -1) {
      currentViewPoint = 'overview';
    } else if (location.pathname.indexOf('component') !== -1) {
      currentViewPoint = 'component';
    } else if (location.pathname.indexOf('security') !== -1) {
      currentViewPoint = 'security';
    } else if (location.pathname.indexOf('license') !== -1) {
      currentViewPoint = 'license';
    } else if (
      location.pathname.indexOf('policy') !== -1
      && location.pathname.indexOf('project') !== -1
    ) {
      currentViewPoint = 'policy';
    }
    api
      .toggleBookmark(
        {
          uploaded_file_id: overviewSummary.uploadedFileId,
          view_point: currentViewPoint,
        }
      )
      .then((response) => {
        const res = response.response;
        this.setState((prevState) => {
          return {
            overviewSummary: {
              ...prevState.overviewSummary,
              isBookmark: res.is_bookmark,
            }
          };
        });
        state.report.setActiveBookMark();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onUpdateLoading = () => {
    this.setState({
      isLoading: true,
    });
  };

  getComponentSummaryDetail = async (value, type) => {
    const { state } = this.props;

    try {
      const response = await api.getComponentSummaryDetail(value, type);
      const data = convertPropertiesToCamelCase(response.response);

      this.setState({
        overviewSummary: data,
        componentCount: data.componentCount,
      });
      state.company.setComponentSummaryDetail(data);
      state.user.setUpdateSummaryValue(false);
    } catch (err) {
      console.log(err);
      const o = err.data.response;
      if (!o) {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'Unknown error. Please contact Insignary.',
        });
      } else if (o.error === '422-401') {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'You do not have permission to access this file.',
        });
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  closeExportModal = () => {
    this.setState({
      modalExportIsOpen: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isDownloadingReport: false,
      isOpenMNA: false,
      isOpenMVX: false,
      toExport: '',
    });
  };

  closeModal = () => {
    this.setState({
      isOpenAlertModal: false,
      isOpenMCB: false,
    });
  };

  downloadReport = (exportFormat, exportType, toExport) => {
    const { t, state } = this.props;
    const { currentPrecisionLevel } = state.user;
    const { overviewSummary } = this.state;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${overviewSummary.uploadedFileId}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${overviewSummary.uploadedFileId}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });

        if (overviewSummary.currentPrecisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (overviewSummary.currentPrecisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = overviewSummary.currentPrecisionLevel;
        }
        const fileName = `${overviewSummary.uploadName}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = t('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = t('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{t('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{t('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = t('modal.message.export_send_email');
          this.modalHeader = t('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = t('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = t('modal.title.attention');

        if (!o.error) {
          this.modalBody = t('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = t('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = t('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = t('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = t('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });
      });
  };

  goBack = () => {
    history.back();
  };

  abbreviateNumber = (value) => {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  };

  drawChart = () => {
    const { componentCount } = this.state;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const { total, has_risk } = componentCount;

    const config = {
      type: 'pie',
      data: {
        datasets: [
          {
            label: ['risk', 'safety'],
            data: [has_risk, total - has_risk],
            backgroundColor: ['#FF7D00', '#8A6FEB'],
            borderWidth: 0,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
        //maintainAspectRatio: false,
        //responsive: true,
      },
    };

    const ctx = this.canvas.getContext('2d');
    this.chart = new Chart(ctx, config);
  };

  renderBookMark = () => {
    const { overviewSummary } = this.state;
    if (overviewSummary.isBookmark) {
      return (
        <a className="icon_box" onClick={this.handleBookmark} onKeyUp={this.handleBookmark}>
          <Icon name="bookmark" />
        </a>
      );
    }
    return (
      <a className="icon_box" onClick={this.handleBookmark} onKeyUp={this.handleBookmark}>
        <Icon name="bookmark outline" />
      </a>
    );
  };

  render() {
    const {
      litigatorData,
      overviewSummary,
      isLoadError,
      errorHeader,
      errorBody,
      isOpenMenu,
      isOpenAlertModal,
      toExport,
      isOpenMNA,
      isOpenMCB,
      isOpenMLD,
      isOpenMCX,
      isOpenMCD,
      isOpenMVX,
      modalExportIsOpen,
      isDownloadingReport,
    } = this.state;
    const { t, state, params } = this.props;

    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    const {
      componentCount,
      mostFound,
      mostVulnerable,
      projectName,
      projectVersionName,
      uploadName,
      currentPrecisionLevel,
    } = overviewSummary;

    return (
      <div>
        <div className="result_header has_expand">
          <div className="result_header_inner">
            <div className="result_header_box">
              {
                !isLoadError ? (
                  <div className="name">
                    <div className="prev_button">
                      <a onClick={this.goBack} onKeyUp={this.goBack} />
                    </div>
                    <Breadcrumb
                      style={{
                        lineHeight: '14px',
                        opacity: '0.5',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        color: '#ffffff',
                        position: 'absolute',
                        top: '-5px',
                      }}
                    >
                      <Breadcrumb.Section>
                        {projectName}
                      </Breadcrumb.Section>
                      <Breadcrumb.Divider style={{ color: '#ffffff' }}>/</Breadcrumb.Divider>
                      <Breadcrumb.Section>
                        {projectVersionName}
                      </Breadcrumb.Section>
                    </Breadcrumb>
                    <div className="file_name">
                      <span>
                        {uploadName}
                      </span>
                      <Popup
                        trigger={(
                          <a className="icon_box">
                            <Icon name="file code outline" />
                          </a>
                        )}
                        on="click"
                        className="sbom_menu"
                        position="bottom left"
                        open={isOpenMenu}
                        onOpen={this.handleMenuOpen}
                        onClose={this.handleMenuClose}
                      >
                        <Menu
                          vertical
                        >
                          {
                            state.user.use_crypto
                            && (
                              <Menu.Item
                                link
                                onClick={this.handleCBOM}
                              >
                                <Icon name="download" style={iconStyle} />
                                CBOM
                              </Menu.Item>
                            )
                          }
                          <Menu.Header className="section_title">SBOM</Menu.Header>
                          <Menu.Item
                            link
                            onClick={this.handleExport}
                          >
                            <Icon name="download" style={iconStyle} />
                            {t('card.menu.clarity')}
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleSpdx}
                          >
                            <Icon name="download" style={iconStyle} />
                            {t('card.menu.spdx')}
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleCycloneDx}
                          >
                            <Icon name="download" style={iconStyle} />
                            CycloneDX
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleVexBom}
                          >
                            <Icon name="download" style={iconStyle} />
                            VEX
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleNIS}
                          >
                            <Icon name="download" style={iconStyle} />
                            NIS
                          </Menu.Item>
                        </Menu>
                      </Popup>
                      {this.renderBookMark()}
                      {currentPrecisionLevel === 'narrow' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle up"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_narrow')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'medium' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="exchange"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_medium')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'broad' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle down"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_broad')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                    </div>
                  </div>
                )
                  : (
                    <HeaderError
                      errorHeader={errorHeader}
                      errorBody={errorBody}
                      goBack={this.goBack}
                    />
                  )
              }
              <HeaderLinkDetail overviewSummary={overviewSummary} props={this.props} />
            </div>
          </div>
          <ExportModal
            isOpenMED={modalExportIsOpen}
            onClose={this.closeExportModal}
            handleModal={this.downloadReport}
            isDownloading={isDownloadingReport}
            birdView
            rowData={overviewSummary}
            translate={t}
          />
        </div>
        <div
          className="contents_summary"
        >
          <div className="contents_summary_inner">
            <div className="contents_summary_box">
              <table className="summary_item_table">
                <colgroup>
                  <col width="30%" />
                  <col width="30%" />
                  <col width="" />
                </colgroup>
                <tbody>
                  <tr>
                    <td>
                      <div className="summary_item">
                        <p className="label">{t('panel.menu.component')}</p>
                        <p className="value">{componentCount && this.abbreviateNumber(componentCount.total)}</p>
                      </div>
                      <div className="summary_chart pie">
                        <span className="value">
                          {componentCount && this.abbreviateNumber(componentCount.has_risk)}
                        </span>
                        <canvas
                          className="pie_chart"
                          //style={{ width: '46px', height: '46px' }}
                          ref={(ref) => {
                            this.canvas = ref;
                          }}
                        />
                      </div>
                      <div className="summary_issues">
                        <div className="no_issue">
                          <p className="label">{t('panel.menu.no_issue')}</p>
                          <p className="val">
                            {
                              componentCount ? this.abbreviateNumber(componentCount.total - componentCount.has_risk) : null
                            }
                          </p>
                        </div>
                        <div className="with_issue">
                          <p className="label">{t('panel.menu.with_issue')}</p>
                          <p className="val">{componentCount && this.abbreviateNumber(componentCount.has_risk)}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="list_wrap">
                        <p className="list_title">{t('panel.menu.most_found_components')}</p>
                        <ul>
                          {mostFound && mostFound.length !== 0 ? (
                            <li className="normal">
                              <table style={{ tableLayout: 'fixed' }}>
                                <colgroup>
                                  <col width="" />
                                  <col width="15%" />
                                </colgroup>
                                <tbody>
                                  {mostFound.map((item) => {
                                    return (
                                      <tr key={uuidv4()}>
                                        <td className="name">{item.component_name}</td>
                                        <td>{item.scanned_file_count}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div className="list_wrap">
                        <p className="list_title">{t('panel.menu.most_vulnerable_components')}</p>
                        <ul>
                          {mostVulnerable && mostVulnerable.length !== 0 ? (
                            <li className="normal">
                              <table style={{ tableLayout: 'fixed' }}>
                                <colgroup>
                                  <col width="50%" />
                                  <col width="15%" />
                                  <col width="15%" />
                                  <col width="" />
                                </colgroup>
                                <tbody>
                                  {mostVulnerable.map((item) => {
                                    return (
                                      <tr key={uuidv4()}>
                                        <td className="name">{item.component_name}</td>
                                        <td>
                                          <div
                                            className={cx(
                                              'bullet',
                                              {
                                                red: item.security_count.top_risk === 'critical',
                                              },
                                              {
                                                orange: item.security_count.top_risk === 'high',
                                              },
                                              {
                                                cheese: item.security_count.top_risk === 'medium',
                                              },
                                              {
                                                yellow: item.security_count.top_risk === 'low',
                                              }
                                            )}
                                          >
                                            {item.security_count.total}
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className={cx(
                                              'bullet round',
                                              {
                                                red:
                                                item.license_count.top_risk === 'protective'
                                                && item.license_count.total !== 0,
                                              },
                                              {
                                                orange:
                                                item.license_count.top_risk === 'permissive'
                                                && item.license_count.total !== 0,
                                              },
                                              {
                                                yellow:
                                                item.license_count.top_risk === 'others'
                                                && item.license_count.total !== 0,
                                              }
                                            )}
                                          >
                                            {item.license_count.total}
                                          </div>
                                        </td>
                                        <td
                                          className="name has_link"
                                          style={{
                                            fontSize: '10px',
                                            padding: '0px',
                                          }}
                                        >
                                          <span
                                            onClick={(e) => {
                                              return this.handleLitigatorDetailModal(
                                                e,
                                                item.litigator_string
                                              );
                                            }}
                                            onKeyUp={(e) => {
                                              return this.handleLitigatorDetailModal(
                                                e,
                                                item.litigator_string
                                              );
                                            }}
                                          >
                                            {item.litigator_string}
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <LitigatorDetailModal
            isOpenMLD={isOpenMLD}
            closeModal={this.handleMLDClose}
            litigatorData={litigatorData}
          />
          <SPDXDocumentGenerator
            isOpenMCX={isOpenMCX}
            reportId={params.idReport}
            uploadedFileName={uploadName}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <CycloneDXDocumentGenerator
            isOpenMCD={isOpenMCD}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <VexGenerator
            isOpenMVX={isOpenMVX}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <NISModal
            isOpenMNA={isOpenMNA}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <CBOMGenerator
            isOpenMCB={isOpenMCB}
            reportId={params.idReport}
            fileName={uploadName}
            closeModal={this.closeModal}
            translate={t}
          />
          <Modal open={isOpenAlertModal} onClose={this.closeModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  {
                    toExport === 's3' ? (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        {this.modalHeader}
                        {this.modalSubBody}
                      </Modal.Description>
                    ) : (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        <p className="modal_list">{this.modalHeader}</p>
                        <p>{this.modalSubBody}</p>
                      </Modal.Description>
                    )
                  }

                  <div className="button_wrap">
                    <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default WithRouter((withTranslation()(inject('state')(observer(ComponentDetailedPanel)))));
